import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { INavGroup, INavItem } from '../../../../../models/Menu';
import { activeNavGroup } from '../../../../../store/slicers/menu.slicers';
import { RootState } from '../../../../../store/store';
import { DrawerClosedWithSubmenus } from './components/DrawerClosedWithSubmenus';
import { DrawerOpenWithSubmenus } from './components/DrawerOpenWithSubmenus';

interface NavGroupProps {
  item: INavGroup;
}

const isMatchingUrl = (itemUrl: string, path: string): boolean => {
  return itemUrl === path || itemUrl === path.substring(1);
};

const isAnyChildEnabled = (item: INavItem, openNavItem: number, path: string): boolean => {
  if (item.children && item.children.length > 0) {
    return item.children.some((child: INavItem) => isAnyChildEnabled(child, openNavItem, path));
  }
  return item.id === openNavItem || isMatchingUrl(item.url, path);
};

export const NavGroup: React.FC<NavGroupProps> = ({ item }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const { drawerOpen, openNavGroup, openNavItem } = useSelector((state: RootState) => state.menu);

  const navItemSelected = isAnyChildEnabled(item, openNavItem, location.pathname);
  const groupOpen = openNavGroup.includes(item.id);

  useEffect(() => {
    if (
      isMatchingUrl(item.url || '', location.pathname) ||
      item.children?.some((child: INavItem) => isMatchingUrl(child.url || '', location.pathname))
    ) {
      dispatch(activeNavGroup({ openNavGroup: item.id }));
    }
  }, [item, location.pathname, dispatch]);

  return (
    <>
      {drawerOpen ? (
        <DrawerOpenWithSubmenus item={item} groupOpen={groupOpen} navItemSelected={navItemSelected} />
      ) : (
        <DrawerClosedWithSubmenus item={item} navItemSelected={navItemSelected} />
      )}
    </>
  );
};
